import React, { Component } from "react";
import CaseStudyTitle from "../Components/CaseStudyTitle";
import InfoCard from "../Components/InfoCard";
import TheProblem from "../Components/TheProblem";
import CenterIntro from "../Components/CenterIntro";
import LeftIntro from "../Components/LeftIntro";
import RightIntro from "../Components/RightIntro";
import CounterSection from "../Components/CounterSection";
import Testimonials from "../Components/TestimonialCarousel";
import ImageGallery from "../Components/ImageGalleryThreeCol";

import caseStudyCover from "../Assets/img/affinity/affinity-thumbnail.png";
import AffinityPrototype from "../Assets/img/affinity/affinity-walkthru.gif";
import MVP from "../Assets/img/affinity/sketches.jpg";
import intro from "../Assets/img/affinity/intro.png";
import colors from "../Assets/img/affinity/colors.png";
import policyholdersv1 from "../Assets/img/affinity/Policyholdersv1.png";
import policyholdersv2 from "../Assets/img/affinity/Policyholdersv2.png";
import screenflow from "../Assets/img/affinity/screenflow.png";
import feedback from "../Assets/img/affinity/feedback.png";
import bound from "../Assets/img/affinity/Bound.png";
import newquote1 from "../Assets/img/affinity/NewQuote1.png";
import components from "../Assets/img/affinity/components2.png";
import logo from "../Assets/img/affinity/logo.png";
import { color, motion } from "framer-motion";
import { prototype } from "events";

const myQuotes = [
  {
    quote:
      "Working with Kim completely transformed our brand presence. Her eye for detail and thoughtful approach elevated everything we put in front of our audience.",
    name: "Sarah Chen",
    role: "Head of Product",
    company: "Luminary Labs",
    rating: 5,
    bg: "#D9E8D4",
  },
  {
    quote:
      "From the very first conversation, Kim made the process feel effortless. The final result was beyond what we imagined — elegant, functional, and truly us.",
    name: "Marcus Reid",
    role: "CEO",
    company: "Forge Digital",
    rating: 5,
    bg: "#C8DFF0",
  },
  {
    quote:
      "I've collaborated with many designers over the years. Kim stands apart — she listens deeply and translates ideas into visuals that feel both fresh and timeless.",
    name: "Priya Nair",
    role: "Marketing Director",
    company: "Axiom Studio",
    rating: 5,
    bg: "#DDD5ED",
  },
  {
    quote:
      "Professional, warm, and incredibly talented. Kim delivered ahead of schedule with work that genuinely exceeded our expectations every step of the way.",
    name: "Tom Vasquez",
    role: "Founder",
    company: "Strata Works",
    rating: 5,
    bg: "#F5E6D0",
  },
];

class Affinity extends Component {
  render() {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ y: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.75, ease: "easeOut" }}
      >
        <div class="case-study">
          <CaseStudyTitle
            title="A marketplace for transacting specialty insurance"
            company="Affinity Advisors"
            chips={["Web", "0-1 Product", "Prototyping", "Front-end dev"]}
          />
          <div class="container">
            <div
              class="case-study-hero img-shadow"
              style={{ backgroundImage: "url(" + caseStudyCover + ")" }}
            ></div>

            <div className="row middle-sm">
              <div className="col-md-4 text-right">
                <img src={logo} alt="Affinity Logo" />
              </div>
              <div className="col-md-7">
                <p className="lead">
                  Affinity Advisors is a lean startup that aims to build the
                  leading B2B platform for brokers and agents to streamline the
                  speciality insurance process.
                </p>
              </div>
            </div>
            <TheProblem
              chip=""
              title="Project Overview"
              content={[
                "The co-founders wanted to launch an MVP from the ground up with new code and designs to make it more scalable for rapid growth.",
                "I was responsible for creating the design system, designs & prototypes, and creating the ReactJS front-end components.",
              ]}
              role="Product Designer, Front-end dev"
              timeline="2 months"
              team="2 engineers, 3 co-founders (CEO, CRO, CTO)"
              img={intro}
            />
            <section className="mt-10">
              <CenterIntro
                chip="Discovery & research"
                title="Gathering feedback"
                content={[
                  "Affinity’s target audience consists of insurance brokers and agents that work with companies to rate/quote/bind specialty insurance lines like cyber security, professional liability, technology errors and omissions, etc. We met with potential clients to find out pain points and their needs when generating insurance quotes.",
                ]}
              />
              <div className="row">
                <div className="col-md-4">
                  <InfoCard
                    style="#E8F3DA"
                    title="The ability to compare multiple quotes at once"
                    content={[
                      "Users would sometimes compare 10 insurance quotes at once, so we would have to create a solution that could gracefully handle that.",
                    ]}
                  />
                </div>
                <div className="col-md-4">
                  <InfoCard
                    style="#E8F6FF"
                    title="A lightweight CRM to manage and bind quotes"
                    content={[
                      "The insurance industry is plagued by archaic processes, PDFs, and mountains of paperwork, slowing down the process of binding quotes. Users wanted to manage policyholders in one place.",
                    ]}
                  />
                </div>
                <div className="col-md-4">
                  <InfoCard
                    style="#DFDDF9"
                    title="One-click quote binding"
                    content={[
                      "Users wanted to bind quotes effortlessly and seamlessly within a few minutes through our platform and keep track of the process in one place.",
                    ]}
                  />
                </div>
              </div>
            </section>

            <section className="section green">
              <LeftIntro
                chip="Strategy"
                title="Defining the MVP"
                content={[
                  "The company was moving quickly to launch a new B2B product and needed an MVP that could be shown to potential clients as soon as possible. The cofounders were focused on getting something tangible in front of customers, which meant the turnaround for this work was fast and the experience needed to be intentionally scoped.",
                  { header: { level: 4, text: "Main functionalities needed" } },
                  {
                    bullets: [
                      "The policyholder table view, where brokers and agents could manage their policyholders, and a way to add new ones",
                      "A policyholder details page",
                      "Ability to generate quotes and compare multiple quotes at once",
                      "Ability to bind quotes",
                      "Basic profile and user management",
                    ],
                  },
                ]}
                img={MVP}
              />
              <div className="row middle-sm">
                <div className="col-md-5">
                  <img className="img-shadow" src={colors} width="100%" />
                </div>
                <div className="col-md-7">
                  <h4 className="m-0">
                    Creating the design system and components
                  </h4>
                  <p>
                    Before working on screens, I wanted to{" "}
                    <strong>define the components, colors, and fonts</strong> I
                    would be using to build the designs. Because there wasn't a
                    lot of time for something more customized, using the basic
                    MUI components layered with some custom CSS would help
                    engineers implement the designs quickly. This would also
                    help support rapid growth beyond the MVP and allow it to
                    scale quickly.
                  </p>
                  <p>
                    The colors were fairly basic, playing off of the Affinity
                    blue with some neutral grays as the app bg and other
                    structually defining areas that were ADA compliant. This was
                    just a starting point, as later on I would add more UI
                    colors, such as colors for success, errors, warnings, etc.
                  </p>
                </div>
              </div>

              <img className="img-shadow" src={components} width="100%" />
            </section>
            <section>
              <CenterIntro
                chip="Design"
                title="Designing the user flow"
                content={[
                  "Using early feedback from clients and internal stakeholders, along with competitive research, I defined the core user flows and designed the new interface from the ground up. Given the tight timeline, I **prioritized foundational workflows** rather than fully fleshing out edge cases, with the understanding that the product would continue to evolve after launch.",
                ]}
              />
              <div className="card dark">
                <img src={screenflow} width="100%" />
              </div>

              <div className="col-md-7 text-center m-auto">
                <p>
                  The cofounders were very involved in the design process,
                  generating a lot of ideas on how the product should look. We
                  would meet once a week to go over the designs that I had so
                  far. Sometimes the feedback was more vague, such as 'make it
                  look professional', so I would ask them to send me examples of
                  products they liked and emulate a similar look and feel.
                </p>
                <p>
                  I met with the CTO the most, asking what was feasible in the
                  tight deadline we had looming over us. There was a lot of
                  trade-offs that I had to make to ensured we delivered on
                  times, as our CRO was already meeting with potential clients
                  who were interested in the product.{" "}
                </p>
              </div>
            </section>
            <section className="section blue">
              <CenterIntro
                chip="Feedback & iteration"
                title="Iterating based off feedback"
                content={[
                  "We showed the prototypes to clients and prospective clients and rapidly iterated based on their feedback, going through several cycles of feedback. Showing these new designs during sales calls helped gain more traction in acquiring new clients as well.",
                ]}
              />
              <div className="row">
                <div className="col-md-6">
                  <h4 className="text-center">1st version</h4>
                  <img src={policyholdersv1} width="100%" />
                  <p className="text-small">
                    This first version used list cards to separate each
                    policyholder a broker or agent was responsible for. I was
                    experimenting with a look, wondering if it could look
                    different than a table. However, after showing this to
                    clients, they found it difficult to skim, especially when
                    there was many. Sometimes different isn't best!
                  </p>
                </div>
                <div className="col-md-6">
                  <h4 className="text-center">After feedback</h4>
                  <img src={policyholdersv2} width="100%" />
                  <p className="text-small">
                    I added the policyholders to a table so that users could
                    easy skim through their policyholders with a searchbar. I
                    wanted to add a filter to sort the table, but because of
                    time constrictions, I wasn't able to. But that would be
                    something we added later when we could revisit this page.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <RightIntro
                chip="Coding & launch"
                title="Launching the MVP"
                content={[
                  "Alongside the engineers I worked with, I coded ReactJS components to organize and scale the front-end framework. With the MUI components, I stacked custom CSS on top to deliver faster rather than create a custom framework from the ground up.",
                  "Throughout the process, I would meet with the CTO and a few engineers several times a week to tackle any outstanding items we needed to deliver, prioritize what needed to be worked on next, and answer any of the questions the developers had about the designs they were implementing. ",
                  "After 2 months, we launched the new platform and received plenty of feedback from current and prospective clients on bugs and improvements.",
                ]}
                img={AffinityPrototype}
              />

              <div className="row">
                <div className="col-md-6">
                  <img
                    src={bound}
                    className="img-dropshadow"
                    width="100%"
                    style={{ margin: 0 }}
                  />
                </div>
                <div className="col-md-6">
                  <img
                    src={newquote1}
                    className="img-dropshadow"
                    width="100%"
                    style={{ margin: 0 }}
                  />
                </div>
                {/* <div className="col-md-6">
                  <img src={newquote2} width="100%" />
                </div> */}
              </div>
            </section>

            <section className="section teal">
              <CenterIntro
                chip="Results"
                title="Increased sales & setting the design foundation"
                content={[
                  "After the MVP was released and bugs were squashed, the CRO started showing the new platform to potential clients. Clients were pleased with how it looked and felt and were eager to sign up with Affinity. The new design also helped set the design language for the future, even after I finished and another designer took over. ",
                  "The platform now has **15 large commercial insurance brokerages** with **3,000+ users** using it every day to quote and bind policies thanks to the new design and technical enhancements.",
                ]}
              />

              <CounterSection
                counters={[
                  {
                    value: 15,
                    label: "Clients Onboarded",
                    duration: 2000,
                    easing: "easeOutQuart",
                  },
                  {
                    value: 3000,
                    label: "Active Users",
                    duration: 2500,
                    easing: "easeOutQuart",
                  },
                ]}
              />
            </section>
          </div>

          <div className="container mt-10">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-sm-6">
                <div className="text-right">
                  <a href="/case-study/webbuilder">
                    Redesigning a website builder →
                  </a>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </motion.div>
    );
  }
}

export default Affinity;
